import { FE_MILLION_LINT_FILTERS_OPTIMIZATION_250127 } from "@faire/retailer-settings/FE_MILLION_LINT_FILTERS_OPTIMIZATION_250127";

import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingMillionLintFiltersOptimization = (): boolean =>
  useSetting(FE_MILLION_LINT_FILTERS_OPTIMIZATION_250127);

export const useAssignMillionLintFiltersOptimization = () =>
  useAssignSetting(FE_MILLION_LINT_FILTERS_OPTIMIZATION_250127);
